import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Reset from './Reset'
import { actions } from '../../store'

const mapStateToProps = state => ({
  organization: state.organization
})

const mapDispatchToProps = dispatch => bindActionCreators({
  resetPassword: actions.user.resetPassword
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Reset)



// WEBPACK FOOTER //
// ./src/views/Reset/index.js